<div *ngIf="menuEnabled" class="wrap-float-menu">
  <!-- btn left -->
  <div id="left-zone">
    <ng-container *ngIf="leftBtn">
      <a (click)="onBtnClicked(leftBtn.type,leftBtn.link)" (keyup)="onBtnClicked(leftBtn.type)" aria-disabled="true"
        class="left-right-zone">
        <mat-icon>{{leftBtn.icon}}</mat-icon>
        <span class="btn-text">{{leftBtn.text}}</span>
      </a>
    </ng-container>
  </div>

  <!-- main zone -->
  <div id="main-zone" [ngSwitch]="mainBtnType">
    <!-- btn list -->
    <ul id="shortcuts">
      <li class="shortcuts-item" *ngFor="let item of shortcuts">
        <button mat-mini-fab color="primary" [appTooltip]="item.text" matTooltipPosition="left"
          (click)="onBtnClicked(item.type)">
          <mat-icon>{{item.icon}}</mat-icon>
        </button>
      </li>
    </ul>

    <!-- main btn -->
    <ng-container *ngSwitchCase="'addProperty'">
      <ng-content *ngTemplateOutlet="mainBtnAddProp"></ng-content>
    </ng-container>
    <ng-container *ngSwitchCase="'addInProperty'">
      <ng-content *ngTemplateOutlet="mainBtnPropMain"></ng-content>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <button *ngIf="mainBtn" mat-fab color="primary" id="main-btn" class="add" (click)="onBtnClicked(mainBtn.type)"
        [disabled]="mainBtn.disabled" [appTooltip]="mainBtn.tooltip">
        <mat-icon>{{mainBtn.icon}}</mat-icon>
      </button>
    </ng-container>
  </div>

  <!-- btn right -->
  <div id="right-zone">
    <ng-container *ngIf="rightBtn">
      <a (click)="onBtnClicked(rightBtn.type,rightBtn.link)" (keyup)="onBtnClicked(rightBtn.type)" aria-disabled="true"
        class="left-right-zone">
        <mat-icon [matBadge]="rightBtn.chip" [appTooltip]="rightBtn.chipText" [matBadgePosition]="'above after'"
          matBadgeColor="warn" [matBadgeSize]="'small'">{{rightBtn.icon}}</mat-icon>
        <span>{{rightBtn.text}}</span>
      </a>
    </ng-container>
  </div>
</div>

<ng-template #mainBtnAddProp>
  <button *ngIf="canAddProperty" mat-fab color="primary" id="main-btn" class="add-out-prop"
    (click)="onBtnClicked('addProperty')" [disabled]="hasReachedPropertyLimit"
    [appTooltip]=" hasReachedPropertyLimit ? 'Un compte gratuit n\'autorise la gestion que d\'un seul bien' : 'Ajouter un nouveau bien'"
    matTooltipPosition="left">
    <mat-icon aria-label="Ajouter un nouveau bien">home</mat-icon>
  </button>
</ng-template>

<ng-template #mainBtnPropMain>
  <button *ngIf="canUpdateProperty" mat-fab color="primary" id="main-btn" class="add-in-prop"
    [appTooltip]="'Ajouter des éléments'" matTooltipPosition="left" [matMenuTriggerFor]="menuDoc">
    <!--<mat-icon aria-label="Ajouter des éléments" [svgIcon]="SEND_ICON_KEY"></mat-icon>-->
    <mat-icon aria-label="Ajouter des éléments">add_circle</mat-icon>
  </button>

  <mat-menu #menuDoc="matMenu">
    <span class="m-3">Ajouter</span>
    <button *ngIf="isMobileApp" mat-menu-item (click)="onBtnClicked('scanDoc')">
      <mat-icon color="primary">document_scanner</mat-icon><span>un scan de document</span>
    </button>
    <button mat-menu-item (click)="onBtnClicked('uploadDoc')">
      <mat-icon color="primary">description</mat-icon><span>des documents</span>
    </button>
    <button mat-menu-item (click)="onBtnClicked('uploadPhoto')">
      <mat-icon color="primary">image</mat-icon><span>des photos</span>
    </button>
    <button mat-menu-item (click)="onBtnClicked('addEquipment')">
      <mat-icon color="primary">heat_pump</mat-icon><span>un équipement</span>
    </button>
    <button mat-menu-item (click)="onBtnClicked('addEvent')">
      <mat-icon color="primary">timeline</mat-icon><span>un évènement</span>
    </button>
    <button mat-menu-item (click)="onBtnClicked('addConsumptions')">
      <mat-icon color="primary">leaderboard</mat-icon><span>des consommations</span>
    </button>
    <button mat-menu-item (click)="onBtnClicked('addMaintenance')">
      <mat-icon color="primary">engineering</mat-icon><span>un entretien</span>
    </button>
    <button mat-menu-item (click)="onBtnClicked('addWork')">
      <mat-icon color="primary">construction</mat-icon><span>des travaux</span>
    </button>
    <button *ngIf="canShowPropertyServiceBtnAdd" mat-menu-item (click)="onBtnClicked('addPropertyService')">
      <mat-icon color="primary">contact_page</mat-icon><span>Un service partenaire</span>
    </button>
    <button *ngIf="canShowCustomPropertyServiceBtnAdd" mat-menu-item (click)="onBtnClicked('addCustomPropertyService')">
      <mat-icon color="primary">contact_mail</mat-icon><span>un service</span>
    </button>
    <button *ngIf="canShowPropertySaleBtnAdd" mat-menu-item (click)="onBtnClicked('addPropertySale')">
      <mat-icon color="primary">real_estate_agent</mat-icon><span>un processus de vente</span>
    </button>
  </mat-menu>
</ng-template>